import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { UserPrintViewModel } from "./usersApiSlice";

interface PrintUsersTableProps {
	users: UserPrintViewModel[];
}

export default function PrintUsersTable({ users }: PrintUsersTableProps) {
	const getPageMargins = () => {
		return `@page { margin: 40px 50px 40px 50px !important; size: portrait}`;
	};
	return (
		<>
			<style>{getPageMargins()}</style>
			<h1>Users</h1>
			<DataTable
				value={users}
				dataKey="dT_RowId"
				stripedRows
				emptyMessage="No users found"
				className="tbl tbl-data tbl-datatable min-w-[40rem] cursor-default"
				style={{ paddingTop: "16px" }}>
				<Column header="Name" field="name" />
				<Column header="Username" field="userName" />
				<Column header="External ID" field="externalID" />
				<Column header="Role" field="role" />
			</DataTable>
		</>
	);
}
